module.exports = __webpack_public_path__ + "fonts/temperature.svg?v=493e446f63a6ad8b719b274fafc7073d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/temperature.svg
// module id = 698
// module chunks = 0